import { observer } from 'mobx-react';

import { useFlag } from '../../services/launchDarkly';
import { NotificationDot as NotificationDotNew } from '../NotificationsNew/NotificationDot';

import { NotificationDot } from './NotificationDot';

export const NotificationDotController = observer((props: { type?: 'small' | 'medium' | 'normal' }) => {
  const useRedesignedLounge = useFlag('ui_redesign_lounge', false);
  const ui_redesign_dialogs = useFlag('ui_redesign_dialogs', false);

  if (useRedesignedLounge && ui_redesign_dialogs) {
    return <NotificationDotNew type={props.type} />;
  }

  return <NotificationDot type={props.type} />;
});
